<template>
    <div>
        <h2 class="text-2xl font-bold text-primary">{{title}}</h2>

        <slot></slot>

        <hr class="bg-disabled border-disabled my-10">
    </div>

</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>